import { event, select, selectAll } from 'd3-selection';
import { timer } from 'd3-timer';
import { zoom } from 'd3-zoom';
import * as React from 'react';
import isEqual from 'react-fast-compare';
import { resetflexTicketsThreshold, resetmaxTicketsThreshold } from '../../cart/actions/cart-actions';
import { ItemType } from '../../classes/item-type';
import { PriceType } from '../../classes/price-type';
import { CartSeat, Seat } from '../../classes/seat';
import { SeatingOptionGroup } from '../../classes/seating-option';
import { IPriceRangeModel } from '../../filter/reducers/filter-reducers';
import { CartHelpers } from '../../helpers/cart-helpers';
import isMobile, { isPhone } from '../../helpers/is-mobile';
import { IAppSettingsModel } from '../../reducers/fetch-settings-reducer';
import { closeSeatmapCart, closeSeatmapFilters } from '../../seatmap/actions/seatmap-actions';
import { selectGroupedSeats, selectSeat, selectSingleClickSeat, userChangedZoom } from '../actions/seatmap-actions';
import { isSingleClick } from '../helpers/seatmap-helpers';
import { ISeatMapModel } from '../reducers/seatmap-reducer';
import BackgroundPaths from './background-paths';
import SeatPaths from './seat-paths';

interface IMapProps {
    appSettings: IAppSettingsModel;
    backgroundPaths: Array<string>;
    seatMapModel: ISeatMapModel;
    seats: Array<Seat>;
    selectedSeats: Array<Seat>;
    backgroundImageElement: string;
    dispatch: any;
    cartSeats: Array<CartSeat>;
    priceRangeModel: IPriceRangeModel;
    selectedPriceTypeFilter: Array<PriceType>;
    selectedSpecialSeatingFilter: Array<SeatingOptionGroup>;
    mapStartDragging: () => void;
    mapEndDragging: () => void;
    mapDragging: boolean;
    hoveredSeatId: string;
    isSeatmapView: boolean;

    overlayOpen: boolean;
    filterPanelOpen: boolean;
    showChangeLevelButton: boolean;
    onChangeLevelClick: () => any;
    onNoSelectedPricesForSeatClick: () => any;
    mouseOverSeat: (seats: Array<Seat>, xPos: number, yPos: number) => void;
    mouseOutSeat: () => void;
}

interface IMapState {
    mapScale: number,
    mapScaleSensitivity: number,
    mapMaxZoom: number,
    mapTranslateX: number,
    mapTranslateY: number,
    d3Bound: boolean,
    firstShift: boolean,
    isChrome: boolean
}

class SvgMap extends React.Component<IMapProps, IMapState>{
    svgMap: any;
    transformLayer: any;

    constructor(props: IMapProps) {
        super(props);
        var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);

        this.state = {
            mapScale: window.innerWidth > 770 ? props.appSettings.mapScale
                : (props.seatMapModel.currentZoom !== null ? props.seatMapModel.currentZoom : 1),
            mapScaleSensitivity: props.appSettings.mapScaleSensitivity,
            mapMaxZoom: window.innerWidth > 770 ? props.appSettings.mapMaxZoom : 6,
            mapTranslateX: 0,
            mapTranslateY: 0,
            d3Bound: false,
            firstShift: false,
            isChrome: isChrome
        };
    }

    shouldComponentUpdate(nextProps: IMapProps, nextState: IMapState) {
        return !nextProps.mapDragging &&
            this.props.hoveredSeatId !== nextProps.hoveredSeatId
            || this.props.priceRangeModel.minPrice !== nextProps.priceRangeModel.minPrice
            || this.props.selectedPriceTypeFilter.length !== nextProps.selectedPriceTypeFilter.length
            || this.props.selectedSpecialSeatingFilter.length !== nextProps.selectedSpecialSeatingFilter.length
            || (this.props.selectedSeats.length == 0 || nextProps.selectedSeats.length == 0 ? false
                : this.props.selectedSeats[0].seatId !== nextProps.selectedSeats[0].seatId)
            || this.props.priceRangeModel.maxPrice !== nextProps.priceRangeModel.maxPrice
            || this.props.backgroundPaths.length !== nextProps.backgroundPaths.length
            || this.props.seats.length !== nextProps.seats.length
            //|| (this.props.selectedSeats.length == 0 ? (nextProps.selectedSeats.length > 0 ? true : false)
            //    : (nextProps.selectedSeats.length > 0 ? this.props.selectedSeats[0].seatId !== nextProps.selectedSeats[0].seatId : true))
            || this.props.cartSeats.length !== nextProps.cartSeats.length
            || this.state.mapScale !== nextState.mapScale
            || this.props.seatMapModel.levelBackgroundPaths.length !== nextProps.seatMapModel.levelBackgroundPaths.length
            || (this.props.seatMapModel.seatsHovered.length == 0 || nextProps.seatMapModel.seatsHovered.length == 0 ? true
                : this.props.seatMapModel.seatsHovered[0].seatId !== nextProps.seatMapModel.seatsHovered[0].seatId)
            || this.props.seatMapModel.loadedExchangePricing !== nextProps.seatMapModel.loadedExchangePricing
            || !isEqual(this.props, nextProps);
    }

    _closeFiltersTouch = () => {
        console.log('touch');
        this.props.dispatch(closeSeatmapFilters(false));
        this.props.dispatch(closeSeatmapCart(false));
    }

    _closeFiltersClick = () => {
        console.log('click');
        //this.props.dispatch(closeSeatmapFilters(false));
        //this.props.dispatch(closeSeatmapCart(false));
    }

    render() {
        const useTagPlus = '<use xlink:href="#icon-plus" />';
        const useTagMinus = '<use xlink:href="#icon-minus" />';

        const levelMatch = this.props.appSettings.venueLevels.filter(level => level.id === this.props.seatMapModel.levelId);
        const levelName = levelMatch && levelMatch.length > 0 ? levelMatch[0].name : "";
        //const svgTitleText = formatString(this.props.appSettings.altText !== null ? this.props.appSettings.altText.seatMap : '', [levelName]);

        let mapViewBox = "0 0 1900 1200";

        if (isMobile()) {

            if (isPhone() && this.props.seatMapModel.mobileSeatMapViewBox != null) {
                mapViewBox = this.props.seatMapModel.mobileSeatMapViewBox;
            } else if (this.props.seatMapModel.tabletSeatMapViewBox != null) {
                // iPad size
                mapViewBox = this.props.seatMapModel.tabletSeatMapViewBox;
            }
        }
        return (
            <div className="seatmap-content-map-inner">
                <div className="seatmap-header">
                    {
                        (this.props.appSettings.performanceDateString !== null || this.props.appSettings.venueName.length > 0) ?
                            <p className="caption-paragraph">
                                {
                                    this.props.appSettings.performanceDateString !== null
                                        && (this.props.appSettings.itemType === ItemType.Performance
                                            || this.props.appSettings.itemType === ItemType.Flex
                                            || this.props.appSettings.itemType === ItemType.Exchange) ?
                                        <span className="seatmap-header-date">{this.props.appSettings.performanceDateString}, </span>
                                        : null
                                }
                                {
                                    this.props.appSettings.performanceTimeString !== null
                                        && (this.props.appSettings.itemType === ItemType.Performance
                                            || this.props.appSettings.itemType === ItemType.Flex
                                            || this.props.appSettings.itemType === ItemType.Exchange) ?
                                        <span className="seatmap-header-time">{this.props.appSettings.performanceTimeString}, </span>
                                        : null
                                }
                                {
                                    this.props.appSettings.itemType === ItemType.Super ?
                                        <span className="header-performance-venue">{this.props.appSettings.packageProgressMessage}</span>
                                        :
                                        this.props.appSettings.venueName.length >= 0 ?
                                            <span className="seatmap-header-venue">{this.props.appSettings.venueName}</span>
                                            :
                                            null
                                }
                            </p>
                            : null
                    }

                    <div className="seatmap-header-level">
                        {
                            this.props.seatMapModel.levelId.length > 0 ?
                                <p className="caption-paragraph seatmap-header-level-name">
                                    { levelName }
                                </p>
                                : null}

                        {
                            (this.props.appSettings.changeLevelsButtonText.length > 0 && this.props.seatMapModel.levelId.length > 0 && this.props.showChangeLevelButton) ?
                                <button type="button" className="filters-section-heading-btn" onClick={this.props.onChangeLevelClick.bind(this)} disabled={this.props.filterPanelOpen}>
                                    {this.props.appSettings.changeLevelsButtonText}<span className="visually-hidden"> {this.props.appSettings.venueLevels.filter(lvl => lvl.id === this.props.seatMapModel.levelId)[0].name}</span>
                                </button>
                                : null
                        }
                    </div>
                </div>

                <div className="map-container" id="mapContainer" >
                    <svg id="mapSvg" className="map-svg" viewBox={mapViewBox} preserveAspectRatio="xMidYMin slice" aria-label={levelName}>
                        <g id="transformG">
                            {/* need to delete onces all images have been switched out*/}
                            <g id="svgImage" dangerouslySetInnerHTML={{ __html: this.props.backgroundImageElement }}>
                            </g>
                            <BackgroundPaths
                                paths={this.props.backgroundPaths}
                                seatmapBackgroundPathFill={this.props.appSettings.seatmapBackgroundPathFill}
                                seatmapBackgroundPathStroke={this.props.appSettings.seatmapBackgroundPathStroke} />
                            <SeatPaths
                                usingForceMultipleSeats={this.props.appSettings.forcePatronsReserveInMultiples > 0}
                                dispatch={this.props.dispatch}
                                seats={this.props.seats}
                                seatStyles={this.props.seatMapModel.seatStyles}
                                selectedSeats={this.props.selectedSeats}
                                levelPricing={this.props.seatMapModel.allSeatPricing}
                                selectedPriceTypes={this.props.selectedPriceTypeFilter}
                                selectedSpecialSeatingFilter={this.props.selectedSpecialSeatingFilter}
                                cartSeats={this.props.cartSeats}
                                priceRangeModel={this.props.priceRangeModel}
                                mapDragging={this.props.mapDragging}
                                hoveredSeatId={this.props.hoveredSeatId}
                                mouseOutSeat={this.props.mouseOutSeat}
                                mouseOverSeat={this.props.mouseOverSeat}
                                isChrome={this.state.isChrome}
                                isExchange={this.props.appSettings.exchangeTickets.length > 0}
                                loadedExchangePricing={this.props.seatMapModel.loadedExchangePricing}
                            />
                        </g>
                    </svg>
                </div>
                <div className={"zoom-container " + (this.props.appSettings.showZoomControlRight ? "align-right" : "align-center")}>
                    <button className={"zoom-item" + (this.state.mapScale <= .5 ? " disabled" : "")} onClick={this._minusZoomMap.bind(this)} >
                        {/*TODO: hardcoded text*/}
                        <span className="visually-hidden">Zoom Out on the Seatmap</span>
                        <svg className="zoom-icon-minus" dangerouslySetInnerHTML={{ __html: useTagMinus }} />
                    </button>
                    <button className={"zoom-item" + (this.state.mapScale >= this.state.mapMaxZoom ? " disabled" : "")} onClick={this._plusZoomMap.bind(this)}>
                        {/*TODO: hardcoded text*/}
                        <span className="visually-hidden">Zoom In on the Seatmap</span>
                        <svg className="zoom-icon-plus" dangerouslySetInnerHTML={{ __html: useTagPlus }} />
                    </button>
                </div>
            </div>
        );
    }



    _minusZoomMap() {
        if (this.state.mapScale > .5) {
            const newScale = this.state.mapScale - this.state.mapScaleSensitivity;
            const newState = {
                ...this.state,
                mapScale: newScale
            };

            this.setState(newState as any);
            this.props.dispatch(userChangedZoom(newScale, true));

            var mapZoom = zoom();
            this.svgMap.call(mapZoom.scaleExtent([1, 8])
                .on("zoom", this.zoomed.bind(this)));;
            this.svgMap.call(mapZoom.scaleTo, newScale);
        }
    }

    _plusZoomMap() {
        if (this.state.mapScale < this.state.mapMaxZoom) {
            const newScale = this.state.mapScale + this.state.mapScaleSensitivity;
            const newState = {
                ...this.state,
                mapScale: newScale
            };

            this.setState(newState as any);
            this.props.dispatch(userChangedZoom(newScale, true));
            var mapZoom = zoom();
            this.svgMap.call(mapZoom.scaleExtent([1, 8])
                .on("zoom", this.zoomed.bind(this)));;
            this.svgMap.call(mapZoom.scaleTo, newScale);
        }
    }

    _mouseZoomMap(event) {
        event.preventDefault();
        event.deltaY < 0 || event.deltaX < 0 ? this._plusZoomMap() : this._minusZoomMap();
    }

    componentDidMount() {
        this._initialize(this.props);

        //var mapSvg = document.getElementsByClassName("map-svg")[0];
        //var seatSvg = mapSvg.querySelector(`.seat-path-js`);

        //if (this.state.allSeats.length === 0) {
        //    let newState = { ...this.state } as IMapState;
        //    newState.allSeats = this.props.seats;
        //    this.setState(newState as any);
        //}
    }

    _initialize(nextProps: IMapProps) {
        //let newState = { ...this.state } as IMapState;

        //let changed = false;

        //if (this.state.allSeats.length === 0) {
        //    newState.allSeats = nextProps.seats;
        //    this.setState(newState as any);
        //}
        this.bindD3();
    }

    bindD3() {
        const map = select("#mapSvg");

        var mapZoom = zoom();
        if (isMobile()) {
            map.call(mapZoom.scaleExtent([1, 8])
                .on("zoom", this.zoomed.bind(this))

            );
        } else {
            map.call(mapZoom.scaleExtent([1, 8])
                .on("zoom", this.zoomed.bind(this))
                .on("start", this.props.mapStartDragging.bind(this))
                .on("end", this.props.mapEndDragging.bind(this))
            );
        }


        //if (translateX > 0 && translateY > 0) {
        //    map.call(zoom.translateBy, translateX, translateY);
        //}

        //map.call(zoom.scaleTo, scale);

        this.svgMap = map;
        this.transformLayer = document.getElementById("transformG");
    }

    zoomed() {
        //let mapSvg = 
        let newTransform = event.transform;
        var isIe: boolean = (/MSIE/i.test(navigator.userAgent)) || (/Trident.*rv\:11\./i.test(navigator.userAgent)) || /Edge\/./i.test(navigator.userAgent);
        //need to add a z transform for mobile to utilize GPU
        timer(() => {
            if (isIe) {
                this.transformLayer.setAttribute("transform", newTransform);
            } else {
                let matrix3d = `transform:matrix3d(${newTransform.k},0, 0, 0, 0, ${newTransform.k}, 0, 0, 0, 0, 1, 0, ${newTransform.x},${newTransform.y}, 0, 1)`;
                this.transformLayer.setAttribute("style", matrix3d);
            }

            if (!isMobile() && this.state.mapScale !== newTransform.k) {
                this.setMapScale(newTransform.k);
            }
        });
    }

    setMapScale(newScale: number) {
        const newState = {
            ...this.state,
            mapScale: newScale
        };

        this.setState(newState as any);
    }

    disableClick = () => {
        // disable the ability to click on a seat because users are just click out of the overlay
        return isMobile() && this.props.overlayOpen;
    }

    componentDidUpdate() {
        if (!this.state.d3Bound) {
            var paths = document.getElementsByClassName('seat-path-js');
            var groupPaths = document.getElementsByClassName('seat-group-path-js');

            if (paths.length > 0 || groupPaths.length > 0) {
                selectAll(".seat-path-js")
                    .on('click', (evt, index, array) => {

                        if (!this.disableClick()) {
                            var selectedSeats = this.props.seats.filter(seat => seat.seatId === (array[index] as any).getAttribute('data-seat-id'));

                            if (selectedSeats.length > 0 && (selectedSeats[0].tessituraSeat.isAvailable && !selectedSeats[0].tessituraSeat.isDisabled)) {
                                // Get the price types that are associated with the selected seat.
                                const zonePrice = this.props.seatMapModel.allSeatPricing.filter(pricing =>
                                    pricing.zoneId.toString() === selectedSeats[0].tessituraSeat.zoneId);

                                let selectedPriceTypeIds = this.props.selectedPriceTypeFilter.map(pt => {
                                    return pt.priceTypeId;
                                });

                                const selectedPrices = zonePrice[0].prices.filter(price => {
                                    return selectedPriceTypeIds.indexOf(+price.priceTypeId) >= 0;
                                });

                                // if there are no selected prices, then there's no point in selecting the seat so we will open the ticket type filter instead
                                if (selectedPrices.length == 0) {
                                    this.props.onNoSelectedPricesForSeatClick();
                                } else {
                                    if (CartHelpers.isSetQuantityPackage(this.props.appSettings)) {
                                        this.props.dispatch(resetflexTicketsThreshold());
                                    }

                                    if (isSingleClick(this.props.appSettings.disableOneClick,
                                        this.props.appSettings.enableZoneUpsells,
                                        this.props.appSettings.zoneUpsellEnableForMobile,
                                        selectedSeats, this.props.seatMapModel.zoneUpsells,
                                        this.props.seatMapModel.selectedPriceQuantities,
                                        selectedPrices
                                    )) {
                                        this.props.dispatch(selectSingleClickSeat(selectedSeats[0], this.props.selectedPriceTypeFilter, this.props.appSettings.disableOneClickRemove));
                                    } else {
                                        this.props.dispatch(selectSeat(selectedSeats[0], true, this.props.seatMapModel.seatmapId, this.props.seatMapModel.hasSeatViewImages));
                                    }
                                }


                            }

                            if (this.props.mapDragging) {
                                this.props.mapEndDragging();
                            }
                            //(d3.event as any).sourceEvent.stopPropagation();
                        }
                    }, true);

                selectAll(".seat-group-path-js")
                    .on('click', (evt, index, array) => {
                        if (!this.disableClick()) {
                            var selectedSeats = this.props.seats.filter(seat => (array[index] as any).getAttribute('data-seat-id').indexOf(seat.seatId) >= 0);

                            if (selectedSeats.length > 0 && selectedSeats.some(seat => seat.tessituraSeat.isAvailable)) {
                                //fetch selected seat image
                                this.props.dispatch(resetmaxTicketsThreshold());
                                this.props.dispatch(resetflexTicketsThreshold());

                                // dispatch seat group selection
                                this.props.dispatch(selectGroupedSeats(selectedSeats, this.props.seatMapModel.seatmapId, this.props.seatMapModel.hasSeatViewImages));
                            }

                            //(d3.event as any).sourceEvent.stopPropagation();
                        }
                    }, true);

                const newState = { ...this.state, d3Bound: true };
                this.setState(newState as any);
            }
        } else {
            // commented out until this works.
            //if (!this.state.firstShift) {
            //    this._shiftMapToSeat(this.props, this.state.mapScale);
            //    this.setState(_.assign({}, this.state, { firstShift: true }))
            //}
        }
    }
}

export default SvgMap;